import { render, staticRenderFns } from "./cookiesPolicy.vue?vue&type=template&id=d4820c86&scoped=true"
import script from "./cookiesPolicy.vue?vue&type=script&lang=js"
export * from "./cookiesPolicy.vue?vue&type=script&lang=js"
import style0 from "./cookiesPolicy.vue?vue&type=style&index=0&id=d4820c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4820c86",
  null
  
)

export default component.exports